import { Message,MessageBox } from "element-ui";
import {getToken} from './auth.js'
var url ='wss://testapi.sxjbhyy.com/jbh/websocket/'
//var url ='https://api.sxjbhyy.com/aos/websocket/'
var ws
var tt
var lockReconnect = false //避免重复连接
var clientId = getToken() //cookies中获取token值
var websocket = {
//建立连接
  Init:function(clientId){
    if ('WebSocket' in window) {
        ws = new WebSocket(url + clientId)
      } else if ('MozWebSocket' in window) {
        ws = new MozWebSocket(url + clientId)
      } else {
        // console.log('您的浏览器不支持 WebSocket!')
        return
      }
      ws.onmessage = function (e) {
        console.log('接收消息:' + e.data)
        heartCheck.start()
        if (e.data == 'ok') {
          //心跳消息不做处理
          return
        }
        var id =localStorage.getItem("id")
        if(id == '11936'){
          console.log('管理员用户socket通知')
          MessageBox({
            message: e.data,
            title: '系统消息通知',
            type: 'success'
          })
        }
        // Message({
        //   message: e.data,
        //   type: 'success'
        // })
      }
       ws.onclose = function () {
        console.log('连接已关闭')
        // Message({
        //   message: '报警功能连接已关闭',
        //   type: 'error'
        // })
        reconnect(clientId)
      }
      ws.onopen = function () {
        // console.log('连接成功')
        // Message({
        //   message: '报警功能连接成功',
        //   type: 'success'
        // })
        console.log('socket连接成功')
        heartCheck.start()
      }
      ws.onerror = function (e) {
        // console.log('数据传输发生错误')
        // Message({
        //   message: '数据传输发生错误',
        //   type: 'error'
        // })
        reconnect(clientId)
      }
  },
   onClose: function () {
    console.log('主动关闭连接！')
    //关闭websocket连接和关闭断开重连机制
    lockReconnect = true
    // 调用 上面的websocket关闭方法
    ws.close()
  },
  Send: function (sender, reception, body, flag) {
    let data = {
      sender: sender,
      reception: reception,
      body: body,
      flag: flag
    }
    let msg = JSON.stringify(data)
    // console.log('发送消息：' + msg)
    ws.send(msg)
  },
  // 返回ws对象
  getWebSocket () {
    return ws
  },
  getStatus:function () {
      if (ws.readyState == 0) {
        return '未连接'
      } else if (ws.readyState == 1) {
        return '已连接'
      } else if (ws.readyState == 2) {
        return '连接正在关闭'
      } else if (ws.readyState == 3) {
        return '连接已关闭'
      }
    }
}

// 刷新页面后需要重连
if (window.performance.navigation.type == 1 && getToken() != null) {
  //刷新后重连
  // reconnect(clientId);
  websocket.Init(clientId)
  //如果websocket没连接成功，则开始延迟连接
  if (ws == null) {
    reconnect(clientId)
  }
}

export default websocket
//根据消息标识做不同的处理
function messageHandle (message) {
  let msg = JSON.parse(message)
  switch (msg.flag) {
    case 'command':
      // console.log('指令消息类型')
      break
    case 'inform':
      // console.log('通知')
      break
    default:
    // console.log('未知消息类型')
  }
}
// 重连方法 刷新页面 连接错误 连接关闭时调用
function reconnect (sname) {
  if (lockReconnect) {
    return
  }
  lockReconnect = true
  //没连接上会一直重连，设置延迟避免请求过多
  tt && clearTimeout(tt)
  tt = setTimeout(function () {
    // console.log('执行断线重连...')
    websocket.Init(sname)
    lockReconnect = false
  }, 4000)
}

//心跳检测 跟后端是对应的 会进行处理
// 连接成功 和后端推消息时调用
var heartCheck = {
  timeout: 1000 * 60 * 3,
  timeoutObj: null,
  serverTimeoutObj: null,
  start: function () {
    // console.log('开始心跳检测')
    var self = this
    this.timeoutObj && clearTimeout(this.timeoutObj)
    this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj)
    this.timeoutObj = setTimeout(function () {
      //这里发送一个心跳，后端收到后，返回一个心跳消息，
      //onmessage拿到返回的心跳就说明连接正常
      // console.log('心跳检测...')
      ws.send('HeartBeat:' + clientId)
      self.serverTimeoutObj = setTimeout(function () {
        if (ws.readyState != 1) {
          ws.close()
        }
        // createWebSocket();
      }, self.timeout)
    }, this.timeout)
  }
}



// WEBPACK FOOTER //
// ./src/utils/websocket.js